function Camera() {
  return (
    <svg width={40} height={35} viewBox="0 0 40 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40 8.75v22.5c0 2.07-1.68 3.75-3.75 3.75H3.75C1.68 35 0 33.32 0 31.25V8.75C0 6.68 1.68 5 3.75 5h6.875l.96-2.57A3.745 3.745 0 0115.095 0h9.804c1.563 0 2.961.969 3.508 2.43L29.375 5h6.875C38.32 5 40 6.68 40 8.75zM29.375 20c0-5.172-4.203-9.375-9.375-9.375S10.625 14.828 10.625 20s4.203 9.375 9.375 9.375 9.375-4.203 9.375-9.375zm-2.5 0c0 3.79-3.086 6.875-6.875 6.875-3.79 0-6.875-3.086-6.875-6.875 0-3.79 3.086-6.875 6.875-6.875 3.79 0 6.875 3.086 6.875 6.875z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Camera;
